/**
 * Created by lihanying on 2017/6/30.
 */
import React from 'react'
import { clickDownload } from '../../../util/index'
import { Table, DatePicker, message, Button, Spin } from 'antd'
import moment from 'moment'
import { CLUB_ID } from '../../ClubBusiness/constants'
const { MonthPicker } = DatePicker

export default class extends React.Component {
  state = {
    year_month: '',
    rp_year_month: '',
    loading: false,
  }

  onChange = (value, dateString) => {
    this.setState({ year_month: dateString })
  }

  onSubmit = () => {
    const { year_month } = this.state
    if (year_month.length > 0) {
      let data = {
        club_id: sessionStorage.getItem(CLUB_ID),
        year_month: year_month,
      }
      this.setState({ loading: true, rp_year_month: year_month })
      this.props.fetchClubRevenue(data).then((res) => {
        this.setState({ loading: false })
      }) //营收报表
    } else {
      message.info('请输入时间搜索')
    }
  }

  disabledDate = (current) => {
    return current && current > moment('20180501', 'YYYYMMDD')
  }

  //数据处理
  dataManage = (list) => {
    const income =
      list.income &&
      list.income.map((item) => {
        item.rental_fee_tables = +item.rental_fee_table / 100 //桌台费收入
        item.rental_fee_mahjongs = +item.rental_fee_mahjong / 100 //棋牌房费收入
        item.rental_fee_darts = +item.rental_fee_dart / 100 //飞镖机收入
        item.sum_commodity =
          (+item.sales_table +
            +item.sales_mahjong +
            +item.sales_bar +
            +item.sales_dart) /
            100 || 0 //商品销售收入
        item.charge_generals = +item.charge_general / 100 //会员充值收入
        item.sum_received = (+item.received + +item.rental_fee_bar) / 100 //其他收入
        item.charge_balances = +item.charge_balance / 100 //会员充值余额
        item.ar_balances = +item.ar_balance / 100 //截至本期累计挂账
        item.match_fee = +item.match_fee_member / 100 //会员参赛费
        //合计
        item.sum_fee_income = (
          (+item.rental_fee_table +
            +item.rental_fee_mahjong +
            +item.rental_fee_dart +
            +item.sales_table +
            +item.sales_mahjong +
            +item.sales_bar +
            +item.sales_dart +
            +item.charge_general +
            +item.received +
            +item.rental_fee_bar +
            +item.match_fee_member) /
          100
        ).toFixed(0)

        return item
      })

    const method =
      list.methods &&
      list.methods.map((item) => {
        item.sum_cash = (+item.cash + +item.cash_charge) / 100 //现金收入
        item.sum_wechat = (+item.wechat + +item.balance) / 100 //平台微信收入
        item.sum_card = (+item.card + +item.card_charge) / 100 //银行卡收入
        item.sum_third_part = (+item.third_part + +item.third_part_charge) / 100 //第三方收入
        item.sum_sign = (+item.sign + +item.sign_charge + +item.sign_ared) / 100 //签单
        item.sum_sign_ared =
          (+item.cash_charge +
            +item.cash_ared +
            +item.third_part_ared +
            +item.sign_ared +
            +item.club_balance_ared) /
          100 //本期已挂账
        item.cash_expenditures = +item.cash_expenditure / 100 //现在支出
        item.cash_balances = 0 //现在余额
        item.charge_consume =
          (+item.club_balance + +item.club_balance_ared) / 100 //会员充值消耗

        //合计
        item.sum_platform_income = (
          (+item.cash +
            +item.cash_charge +
            +item.wechat +
            +item.balance +
            +item.card +
            +item.card_charge +
            +item.third_part +
            +item.third_part_charge) /
          100
        ).toFixed(0)

        return item
      })

    const settle =
      list.settle &&
      list.settle.map((item, idx) => {
        item.profits = +item.profit / 100 //会员奖池
        item.prize_pools = +item.prize_pool / 100 //奖池基金
        item.sum_wechat_fee = (+item.wechat_fee + +item.balance_fee) / 100 //腾讯手续费
        item.sun_club_close_income = (
          +income[idx].sum_fee_income -
          +(
            (+item.profit +
              +item.prize_pool +
              +item.wechat_fee +
              +item.balance_fee +
              +item.match_fee_member) /
            100
          )
        ).toFixed(2) //俱乐部结账后应收
        item.prize_pool_use = 0 //奖池资金支用
        item.platform = 0 //平台使用费
        item.match_fee_clubs = +item.match_fee_club / 100 //俱乐部参赛费
        item.match_fee_mb = +item.match_fee_member / 100 //代收会员参赛费
        item.sun_close_income = (
          +method[idx].sum_wechat -
          +(
            (+item.profit +
              +item.prize_pool +
              +item.wechat_fee +
              +item.balance_fee +
              +item.last_forward +
              +item.match_fee_member) /
            100
          )
        ).toFixed(2)

        return item
      })

    let newData = []
    if (income.length > 0) {
      income.map((item, idx) => {
        let obj = {}
        obj = Object.assign(item, method[idx])
        obj = Object.assign(obj, settle[idx])
        newData = [].concat(newData, obj)
      })
    }

    return newData
  }

  render() {
    const { list } = this.props
    const columns = [
      {
        title: '结算日期',
        dataIndex: 'sum_date',
        width: '3.4%',
      },
      {
        title: '桌台费收入',
        dataIndex: 'rental_fee_tables',
        width: '3.4%',
      },
      {
        title: '棋牌房费收入',
        dataIndex: 'rental_fee_mahjongs',
        width: '3.4%',
      },
      {
        title: '飞镖机收入',
        dataIndex: 'rental_fee_darts',
        width: '3.4%',
      },
      {
        title: '商品销售收入',
        dataIndex: 'sum_commodity',
        width: '3.4%',
      },
      {
        title: '会员充值收入',
        dataIndex: 'charge_generals',
        width: '3.4%',
      },
      {
        title: '其他收入',
        dataIndex: 'sum_received',
        width: '3.4%',
      },
      {
        title: '代收会员参赛费',
        dataIndex: 'match_fee',
        width: '3.4%',
      },
      {
        title: '合计',
        dataIndex: 'sum_fee_income',
        width: '3.4%',
        className: 'table-col',
      },
      {
        title: '现金收入',
        dataIndex: 'sum_cash',
        width: '3.4%',
      },
      {
        title: '平台微信收入',
        dataIndex: 'sum_wechat',
        width: '3.4%',
      },
      {
        title: '银行卡收入',
        dataIndex: 'sum_card',
        width: '3.4%',
      },
      {
        title: '第三方收入',
        dataIndex: 'sum_third_part',
        width: '3.4%',
      },
      {
        title: '合计',
        dataIndex: 'sum_platform_income',
        width: '3.4%',
        className: 'table-col',
      },
      {
        title: '会员奖池',
        dataIndex: 'profits',
        width: '3.4%',
      },
      {
        title: '奖池基金',
        dataIndex: 'prize_pools',
        width: '3.4%',
      },
      {
        title: '腾讯手续费',
        dataIndex: 'sum_wechat_fee',
        width: '3.4%',
      },
      {
        title: '平台使用费',
        dataIndex: 'platform',
        width: '3.4%',
      },
      {
        title: '代收会员参赛费',
        dataIndex: 'match_fee_mb',
        width: '3.4%',
      },
      {
        title: '俱乐部参赛费',
        dataIndex: 'match_fee_clubs',
        width: '3.4%',
      },
      {
        title: '俱乐部结算后应收',
        dataIndex: 'sun_close_income',
        width: '3.4%',
      },
      {
        title: '俱乐部结算后营收',
        dataIndex: 'sun_club_close_income',
        width: '3.4%',
      },
      {
        title: '现金支出',
        dataIndex: 'cash_expenditures',
        width: '3.4%',
      },
      {
        title: '现金余额',
        dataIndex: 'cash_balances',
        width: '3.4%',
      },
      {
        title: '奖池基金支用',
        dataIndex: 'prize_pool_use',
        width: '3.4%',
      },
      {
        title: '会员充值消耗',
        dataIndex: 'charge_consume',
        width: '3.4%',
      },
      {
        title: '会员充值余额',
        dataIndex: 'charge_balances',
        width: '3.4%',
      },
      {
        title: '截至本期累计挂账',
        dataIndex: 'ar_balances',
        width: '3.4%',
      },
      {
        title: '本期已收挂账',
        dataIndex: 'sum_sign_ared',
        width: '3.4%',
      },
      {
        title: '签单',
        dataIndex: 'sum_sign',
        width: '3.4%',
      },
    ]

    const reportName = sessionStorage.getItem('reportName')
    const rp_year_month = this.state.rp_year_month
    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <MonthPicker
            size="large"
            disabledDate={this.disabledDate}
            onChange={(value, dateString) => this.onChange(value, dateString)}
          />
          <Button type="primary" onClick={() => this.onSubmit()}>
            查询
          </Button>
          <Button style={{ marginLeft: '2rem' }}>
            <a
              id="test"
              href={clickDownload(columns, this.dataManage(list))}
              download={`${reportName}${rp_year_month}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={this.dataManage(list)}
            pagination={false}
            scroll={{ y: +window.innerHeight - 350 }}
            size="middle"
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRevenue/component/revenue.js